import { decodeHashid, encodeHashid } from "@scrinz/hashids";
import { entityUtils, roleUtils } from "@scrinz/helpers";
// Object with helpers to be made available in Vue component instances.
const SCRINZ_HELPERS = Object.assign(Object.assign(Object.assign({}, entityUtils), roleUtils), { hashid: {
        decode: decodeHashid,
        encode: encodeHashid,
    } });
// The Vue plugin for Scrinz related code.
export const ScrinzVuePlugin = {
    install: (V) => {
        // Setup Vue component instance property.
        V.prototype.$scrinz = SCRINZ_HELPERS;
    },
};
//# sourceMappingURL=ScrinzVuePlugin.js.map